import { useNavigate } from "react-router-dom";

import ConfirmationQuestion from "../../../components/Questions/ConfirmationQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { questionContent } from "../questions";

const MedicalEquipment: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer: ConfirmationAnswer) => {
    setAnswers({
      ...answers,
      medicalEquipment: answer,
      ...(answer !== ConfirmationAnswer.Yes
        ? {
            medicalEquipmentDetail: undefined,
          }
        : {}),
    });
  };

  const onContinue = () => {
    if (answers.medicalEquipment === ConfirmationAnswer.Yes) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.MedicalEquipmentDetail}`);
    } else {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.MiscellaneousDetail}`);
    }
  };

  return (
    <ConfirmationQuestion
      onChange={onChange}
      value={answers.medicalEquipment}
      onContinue={onContinue}
      step={questionContent.medicalEquipment.step}
      title={questionContent.medicalEquipment.title}
      subTitle={questionContent.medicalEquipment.subTitle}
      whyWeWantTexts={questionContent.medicalEquipment.whyWeWantTextsCustomer}
    />
  );
};

export default MedicalEquipment;
